import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CodeEditorService } from "src/service/code-editor.service";

@Component({
    selector: "app-code-editor",
    templateUrl: "./code-editor.component.html",
    styleUrls: ["./code-editor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CodeEditorComponent {
    @Input() code!: string;
    @Input() language!: string;

    constructor(private _codeEditorService: CodeEditorService) { }

    ngAfterViewChecked(): void {
        this._codeEditorService.highlightAll();
    }
}